import PublishingAtAGlance from './publishingAtAGlance.component';
angular.module('HomepageServices').component('publishingAtAGlance', PublishingAtAGlance);

require('./publishingAtAGlanceAccordion');
require('./publishingAtAGlanceErrors');
require('./publishingAtAGlancePending');
require('./publishingAtAGlanceOnHold');
require('./publishingAtAGlancePreferences');
require('./publishingAtAGlancePublished');
require('./publishingAtAGlanceOpenCalendar');



// WEBPACK FOOTER //
// ./app/components/publishingAtAGlance/index.js